import React, {Component} from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import {withRouter} from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
//import OverlayTrigger from "react-bootstrap/OverlayTrigger";
//import Popover from "react-bootstrap/Popover";
import Spinner from "react-bootstrap/Spinner";

//import classes from './ExecutionDetails.module.css';
//import {InfoOutlined} from "@material-ui/icons";

import apiUrl from "../../shared/config";
import {Helmet} from "react-helmet";
//import UserButton from "../UI/UserButton/UserButton";
//import {formatParagraphs} from "../../utils/utils";
//import SuggestedExercise from "../SuggestedExercise/SuggestedExercise";
import ExecutionStep from "./ExecutionStep";
import ExecutionPattern from "../ExecutionPattern/ExecutionPattern";
//import {deepArraySearch} from "../../utils/deepSearch";

class ExecutionDetails extends Component {

    state = {
        execution: null
    };

    componentDidMount() {
        //console.log("In Details mount. Exercise Id: " + this.props.exerciseId);
        if (this.props.executionId &&
            this.props.executionId !== "0" &&
            (!this.props.urlExecutionId || this.props.executionId === this.props.urlExecutionId)) {
            // When the ExerciseDetails mount, only fetch the exercise if the props contains an id, and either the URL
            // doesn't contain an id or the URL contains the same id as the selected id. Otherwise, fetching the
            // exercise will be handled on update
            const url = apiUrl +'Exercises/getExerciseExecutionById';
            const params = {
                params: {
                    exercise_id: this.props.exerciseId,
                    execution_id: this.props.executionId,
                    token: (this.props.token ? this.props.token : '')
                }
            };

            console.log('1 Execution ID: ', this.props.executionId, 'Default Execution Id: ');

            axios.get(url, params)
                .then(response => {
                    this.setState({execution: response.data});
                    window.scrollTo({
                        top: document.getElementById('execution-details').offsetTop,
                        behavior: 'smooth'
                    })
                });
        }
        else if (this.props.exerciseId && this.props.executionId !== "0") {
            let defaultExecutionId = this.props.exerciseId;
            const url = apiUrl +'Exercises/getExerciseExecutionById';
            const params = {
                params: {
                    exercise_id: this.props.exerciseId,
                    execution_id: (this.props.executionId ? this.props.executionId : defaultExecutionId),
                    token: (this.props.token ? this.props.token : '')
                }
            };
            //console.log('2 Execution ID: ', this.props.executionId, 'Default Execution Id: ', defaultExecutionId);
            axios.get(url, params)
                .then(response => {
                    this.setState({execution: response.data});
                    window.scrollTo({
                        top: document.getElementById('execution-details').offsetTop,
                        behavior: 'smooth'
                    })
                });
        }
        else if (this.state.execution && this.props.executionId === null) {
            this.setState({execution: null});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log('Exercise ID: ' + this.props.exerciseId + ' Execution ID: ', this.props.executionId, 'State Execution Id: ', this.state.execution);
        if (
            (this.props.executionId  && this.props.executionId !== "0" && this.props.executionId !== prevProps.executionId) ||
            (this.props.executionId !== "0" &&this.props.exerciseId  && this.props.exerciseId !== prevProps.exerciseId)
        ) {
            if (!this.state.execution || !this.state.execution.execution_id ||
                (this.state.execution && this.state.execution.execution_id !== this.props.executionId)) {
                // This is a hack to show the default execution when an exercise is selected.
                // This works only because of the way the db is populated and only for the first 45 exercises
                // from the book. This is bad, don't do this.
                let defaultExecutionId = '';
                if (
                    (this.props.executionId === undefined || this.props.executionId === null) &&
                    this.props.exerciseId <= 45
                ) {
                    defaultExecutionId = this.props.exerciseId;
                }

                console.log('3 Execution ID: ', this.props.executionId, 'Default Execution Id: ' + defaultExecutionId);
                if ((this.props.executionId === undefined || this.props.executionId === null) && defaultExecutionId === '') {
                    //if there are no executions, then clear the slot in the state as it is an old execution.
                    this.setState({execution: null});
                } else {
                    const url = apiUrl +'Exercises/getExerciseExecutionById';
                    const params = {
                        params: {
                            exercise_id: this.props.exerciseId,
                            execution_id: (this.props.executionId ? this.props.executionId : defaultExecutionId),
                            token: (this.props.token ? this.props.token : '')
                        }
                    };
                    axios.get(url, params)
                        .then(response => {
                            this.setState({execution: response.data});
                            window.scrollTo({
                                top: document.getElementById('execution-details').offsetTop,
                                behavior: 'smooth'
                            })
                        });
                }

            }
        }
        else if (this.state.execution && this.props.executionId === null) {
            this.setState({execution: null});
        }
    }

    // should need to pass token for auth
    deletePostHandler = () => {
        axios.get(apiUrl +'Exercises/delete?exercise_id=' + this.props.id + "&token="+ this.props.token)
            .then(response => {
                this.props.closeExerciseDetails(null);
                this.props.exerciseSelected(null);
                console.log("Delete Success")
            }).catch(() => console.log("Delete Failed"));
    };

    editExerciseHandler = (selectedExerciseId) => {
        this.props.editExercise(selectedExerciseId);
        this.props.closeExerciseDetails(null);
    };

    render () {
        let execution = <div className="d-flex justify-content-sm-center">
            <div className="alert alert-secondary text-center select-alert" role="alert">
                Please select a Execution to view.
            </div>
        </div>;
        if (this.props.executionId && !this.state.pattern && this.state.executionDetailsOpen) {
            execution = <div className="d-flex justify-content-sm-center loading-alert">
                <Button variant="primary" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <span> Loading...</span>
                </Button>{' '}
            </div>;
        }

        //console.log("Execution: " + this.state.execution + " Execution Details Open: " + this.props.executionDetailsOpen);
        //&& this.state.execution.steps
        // Trying to show patterns even if there are no steps for legacy executions
        if (this.state.execution && this.state.execution.patterns && this.props.executionDetailsOpen) {
            //Execution Patterns
            const execution_patterns = this.state.execution.patterns.map((execution_pattern) => {
                return (
                    <React.Fragment key={execution_pattern.pattern_id + "ImplementedPattern"}>
                        <ExecutionPattern implemented_pattern={execution_pattern}/>
                    </React.Fragment>
                )
            });


            let execution_patterns_count = this.state.execution.execution_patterns_count;
            let hidden_execution_patterns_count = this.state.execution.patterns.length
                - this.state.execution.patterns.length;


            const execution_patterns_display = (
                <div className="card">
                    <h3 className="card-header">{execution_patterns_count} pattern{execution_patterns_count === 1 ? '' : 's'} created from this exercise execution.
                        {hidden_execution_patterns_count ? (
                            <span> ({hidden_execution_patterns_count} {hidden_execution_patterns_count === 1 ? 'is' : 'are'} private and not shown)</span>) : ""}
                    </h3>
                    <div className="card-body">
                        <div className="card-text">
                            {execution_patterns}
                            <div style={{textAlign: 'center'}}>
                                {
                                //     this.state.execution.patterns.length > hidden_execution_patterns_count
                                // ? <Button
                                //     variant='link'
                                //     style={{fontSize: 18, alignSelf: 'center'}}
                                //     onClick={() => this.setState({displayed_execution_patterns: this.state.execution.patterns})}
                                // >
                                //     Show All
                                // </Button>
                                // : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            );

            let execution_step_count = 0;
            let return_fragment = "";
            //let step_label = "";
            const execution_steps = this.state.execution.steps.map((execution_step) => {
                execution_step_count++;
                const execution_step_key = "execution-step-key-" + execution_step_count;
                return_fragment = (<ExecutionStep key={execution_step_key} execution_step={execution_step}/>);

                return (return_fragment);
            });

            //Execution Patterns
            const execution_users = this.state.execution.users.map((execution_user) => {
                return (execution_user.display_name)
            });

            const execution_steps_wrapper = () => {
                let info_links = '';
                if (this.state.execution.steps.length > 0) {
                    info_links = (<React.Fragment key="info-links">
                        {execution_steps}
                    </React.Fragment>);
                }

                return info_links;
            };

            const execution_patterns_wrapper = () => {
                let info_links = '';
                if (this.state.execution.patterns.length > 0) {
                    info_links = (<React.Fragment key="info-links">
                        <Row>
                            <Col className="col-sm">
                                {
                                    execution_patterns_display
                                }
                            </Col>
                        </Row>
                    </React.Fragment>);
                }

                return info_links;
            };

            const shareText = 'Pattern Language for Game Design — Pattern Exercises: ' + this.state.execution.exercise_name;

            //const site = String(game_image).replace("http://", '').replace("https://", '').split('/');
            execution = (
                <div className="card pattern-details">
                    <Helmet>
                        <title>{shareText}</title>
                    </Helmet>
                    <h1 className="card-header">
                        {this.state.execution.exercise_name + " Execution: "}
                        <h3>{this.state.execution.seed}</h3>
                    </h1>

                    <div className="card-body">
                        <div className="card-text">
                            <dt className="col-xl-6">
                            {"Exercise completed by: " + execution_users + " on: " + this.state.execution.created}
                            </dt>
                        <Container>
                            <Row>
                                <Col className="col-lg-12 col-xl-12">
                                    <dl className="row">
                                        {execution_steps_wrapper()}
                                    </dl>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-lg-12 col-xl-12 execution-patterns-wrapper" >
                                    {execution_patterns_wrapper()}
                                </Col>
                            </Row>

                        </Container>
                        </div>
                    </div>
                </div>
            );
        }

        return execution;
    }
}

export default withRouter(ExecutionDetails);